module.exports = __webpack_public_path__ + "img/lock.561337fc.svg";